export const env = {
    production: false,
    debugMode: true,
    url_base: 'https://dev.api.catastroantioquia-mas.com',
    api: '/api',
    landing: '/landing-perfil',
    perfil_usuario: '/perfil-usuario',
    administracion: '/administracion',
    crm: '/crm',
    asistente: '/asistente',

    module: {
        api_perfilUser_end: '/api_perfilUser.php',
        mailing_perfilUsuario_end: '/mailing_perfilUsuario.php',
        api_landing_page_end: '/api_landing_page.php',
        ia_general_asis: '/ia_general.php',
    },

    DEFAULT_IMAGES: {
        header: "https://dev.ayuda.catastroantioquia-mas.com/assets/images/home/MedellADn-foto-ProColombia.png",
        caracteristicasdestacadas: "https://dev.ayuda.catastroantioquia-mas.com/assets/images/home/business_woman.png",
        chatbot: "https://dev.ayuda.catastroantioquia-mas.com/assets/images/home/asesor-chat.png",
        imagenvideo: "https://dev.ayuda.catastroantioquia-mas.com/assets/images/home/city.png",
        video: "https://dev.ayuda.catastroantioquia-mas.com/assets/images/home/video.mp4",
        imagenpqrsf: "https://dev.ayuda.catastroantioquia-mas.com/assets/images/home/consult_pqr.png",
        logo: "https://dev.ayuda.catastroantioquia-mas.com/assets/images/home/Logo-gobernación.png",
    },
    URL_PERFIL_USUSARIO: 'https://dev.miperfil.catastroantioquia-mas.com'
}

export const env2 = {
    production: false,
    debugMode: true,
    url_base: 'https://dev.api.cic-ware.com',
    api_1: '/api-1',
    asistente: '/asistente',
    countries: '/countries',


    module: {
        ia_general_end: '/ia_general.php',
        api_end: '/api.php',
        api_countries_end: '/api_countries.php',
        entorno: 'DESARROLLO',
    }
}


export const python = {
    production: false,
    debugMode: true,

    url_base: 'https://dev.api-tasa.valormas.gov.co:5001/ask',
    url_asis: 'https://dev.ia-tasa.valormas.gov.co:5002/ask',
    url_var_env_crm:'https://dev.api.catastroantioquia-mas.com:5000/ask',
    catia: '/catia',
}


export const python_tasa = {
    production: false,
    debugMode: true,

    url_base: 'https://dev.api-tasa.valormas.gov.co:5004/ask',
    url_asis: 'https://dev.ia-tasa.valormas.gov.co:5003/ask',
    url_var_env_crm:'https://dev.api.catastroantioquia-mas.com:5000/ask',
    catia: '/catia',
}
